import axios from 'axios'
import BaseModel from '@/models/BaseModel.js'

export default class ApprovalRequest extends BaseModel {
  fields = {}
  endpoint = process.env.VUE_APP_API_URL + 'approval-requests'

  findOpenFor (targetType, targetId) {
    const params = { target_type: targetType, target_id: targetId }
    return Promise.all([
      axios.get(this.endpoint, { params: { ...params, status: 'on_review' } }),
      axios.get(this.endpoint, { params: { ...params, status: 'returned' } })
    ]).then(responses => {
      const reviewing = responses[0].data.data || []
      const returned = responses[1].data.data || []
      return reviewing[0] || returned[0] || null
    })
  }

  cancel (id) {
    return axios.delete(this.endpoint + '/' + id).then(response => response.data)
  }

  requestChange (targetType, targetId, proposedSnapshot, requestNote = null) {
    return axios.post(this.endpoint, {
      target_type: targetType,
      target_id: targetId,
      action: 'update',
      proposed_snapshot: proposedSnapshot,
      request_note: requestNote
    }).then(response => response.data)
  }

  requestReopen (targetType, targetId, requestNote = null) {
    return axios.post(this.endpoint, {
      target_type: targetType,
      target_id: targetId,
      action: 'reopen',
      request_note: requestNote
    }).then(response => response.data)
  }

  requestDelete (targetType, targetId, requestNote = null) {
    return axios.post(this.endpoint, {
      target_type: targetType,
      target_id: targetId,
      action: 'delete',
      request_note: requestNote
    }).then(response => response.data)
  }

  requestPrintBarcode (targetType, targetId, requestNote = null) {
    return axios.post(this.endpoint, {
      target_type: targetType,
      target_id: targetId,
      action: 'print_barcode',
      request_note: requestNote
    }).then(response => response.data)
  }

  findPrintRequest (targetType, targetId) {
    return axios.get(this.endpoint + '/print/' + targetType + '/' + targetId).then(response => response.data)
  }

  consumePrint (id) {
    return axios.post(this.endpoint + '/' + id + '/consume-print').then(response => response.data)
  }

  resubmitPrint (id, requestNote = null) {
    return axios.patch(this.endpoint + '/' + id, { request_note: requestNote }).then(response => response.data)
  }

  resubmit (id, values) {
    return axios.patch(this.endpoint + '/' + id, values).then(response => response.data)
  }

  approve (id, reviewNote = null) {
    return axios.patch(this.endpoint + '/' + id + '/approve', { review_note: reviewNote }).then(response => response.data)
  }

  returnForRevision (id, reviewNote) {
    return axios.patch(this.endpoint + '/' + id + '/return', { review_note: reviewNote }).then(response => response.data)
  }

  reject (id, reviewNote) {
    return axios.patch(this.endpoint + '/' + id + '/reject', { review_note: reviewNote }).then(response => response.data)
  }
}
